import React from "react";
import "../css/servicenow/servicenow.css";

import servicenowpartner from '../img/icons/servicenow.png';
import eventimg2 from "../img/event/bgimg2.jpg";

import home from "../img/Banner/home.png";

import img1 from "../img/Banner/ServiceNow/bannerimg2.jpg";
import img2 from "../img/Banner/ServiceNow/new1.png";
import img3 from "../img/Banner/ServiceNow/new2.png";
import img4 from "../img/Banner/ServiceNow/bannerimg1.jpg";
import bg from "../img/Banner/ServiceNow/bg.png";

import serviceTeam from "../img/Banner/servicenow-dots.png";

const ServiceNowWashingtonDC = () => {
    return (
        <div className="antialiased ServiceNow-DC">
            {/* 1. Hero Section */}
            <section className="position-relative overflow-hidden d-flex align-items-center justify-content-center py-5 ServiceNow-DC-hero" style={{ minHeight: '600px' }}>
                <div className="position-absolute top-0 start-0 w-100 h-100 z-0">
                    <img
                        alt="B2B tech abstract background"
                        className="w-100 h-100 object-fit-cover opacity-75"
                        style={{ mixBlendMode: 'multiply' }}
                        src={bg}
                    />
                    <div className="position-absolute top-0 start-0 w-100 h-100 hero-overlay"></div>
                </div>

                <div className="position-relative z-1 text-center text-white px-3 mt-5" style={{ maxWidth: '900px' }}>
                    <h1 className="display-4 fw-bold mb-3">ServiceNow Partner in Washington, DC</h1>
                    <h2 className="h4 fw-normal mb-4">ServiceNow Consulting, Implementation, Build & Training</h2>
                    <p className="lead mb-5 fs-6 text-white-80">
                        Tiara Software helps organizations maximize the value of the ServiceNow platform through consulting, implementation, integration, custom application development, AI-powered solutions and ongoing support. We also provide practical ServiceNow training for professionals looking to build skills in administration, development, business analysis and AI.
                    </p>
                    <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mt-4">
                        <a href="/contact" className="btn-brand-primary text-decoration-none">Contact Our Team</a>
                        <a href="/snconfirmation" className="btn-brand-secondary-light text-decoration-none">Register for Training</a>
                    </div>
                </div>
            </section>

            {/* 2. Digital Transformation / Trust Section */}
            <section className="py-5 bg-white ServiceNow-DC-intro">
                <div className="container py-5">

                    <div className="row align-items-center gy-5">

                        {/* Content */}
                        <div className="col-lg-6 pe-lg-5">

                            <span className="text-brand-primary fw-bold text-uppercase tracking-wide">
                                ServiceNow Partner in Washington, DC
                            </span>

                            <h2 className="fw-bold mb-4 mt-2 text-brand-dark">
                                Your ServiceNow Partner for Digital Transformation
                            </h2>

                            <div
                                className="bg-brand-primary rounded mb-4"
                                style={{ height: "4px", width: "80px" }}
                            ></div>

                            <p className="text-secondary mb-3">
                                Choosing the right <strong>ServiceNow partner</strong> can
                                make a significant difference in how effectively your
                                organization implements, adopts and scales the platform.
                            </p>

                            <p className="text-secondary mb-3">
                                Tiara Software provides <strong>ServiceNow consulting and
                                    implementation services</strong> designed around your
                                business processes, technology environment and operational
                                goals. From platform strategy and configuration to
                                integrations, custom development and AI-powered solutions,
                                we help organizations build ServiceNow solutions that
                                support measurable business outcomes.
                            </p>

                            <p className="text-secondary mb-3">
                                Our ServiceNow capabilities span key enterprise workflows
                                including <strong>ITSM, CSM and HRSD</strong>, along with
                                workflow automation, integrations and AI-powered ServiceNow
                                solutions. We also develop custom ServiceNow applications
                                that extend platform capabilities and address specific
                                business requirements.
                            </p>

                            <p className="text-secondary mb-4">
                                Whether you are planning a new ServiceNow implementation,
                                optimizing an existing instance, integrating ServiceNow
                                with enterprise systems or developing custom applications,
                                our team can help you plan and execute your ServiceNow
                                journey.
                            </p>

                            {/* CTA */}
                            <a
                                href="/contact"
                                className="btn btn-primary px-4 py-2"
                            >
                                Contact Us
                            </a>

                        </div>


                        {/* Image */}
                        <div className="col-lg-6">

                            <div className="rounded-4 overflow-hidden border shadow-sm">
                                <img
                                    src={serviceTeam}
                                    alt="Tiara Software ServiceNow consulting team providing digital transformation services"
                                    className="img-fluid w-100"
                                    loading="lazy"
                                />
                            </div>

                        </div>

                    </div>

                </div>
            </section>

            {/* 3. Core Services: Consulting & Build Partner */}
            <section className="py-5 bg-light ServiceNow-DC-services">
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <span className="text-brand-primary fw-bold text-uppercase tracking-wide">
                            ServiceNow Partner
                        </span>

                        <h2 className="fw-bold text-brand-dark mt-2">
                            ServiceNow Consulting, Implementation &amp; Build Partner Services
                        </h2>

                        <p className="text-secondary mx-auto mt-3 mb-0" style={{ maxWidth: "800px" }}>
                            Tiara Software provides ServiceNow Partner capabilities for
                            consulting, end-to-end implementation and custom application
                            development tailored to your business requirements.
                        </p>
                    </div>

                    <div className="row gy-4">

                        {/* Consulting & Implementation */}
                        <div className="col-md-6">
                            <div className="card h-100 p-4 p-md-5 border-0 shadow-sm rounded-4">

                                <div className="icon-box rounded-3 d-flex align-items-center justify-content-center mb-4 bg-brand-primary text-white">
                                    <span className="material-symbols-outlined fs-3">
                                        handshake
                                    </span>
                                </div>

                                <h3 className="h4 fw-bold mb-3 text-brand-dark">
                                    Consulting &amp; Implementation
                                </h3>

                                <p className="text-secondary mb-4">
                                    Tiara Software is authorized to perform end-to-end
                                    implementation of the ServiceNow AI Platform, helping
                                    organizations plan, configure, implement and optimize
                                    ServiceNow solutions according to their business needs.
                                </p>

                                <div className="mb-4 p-3 rounded-3 bg-light border">
                                    <p className="fw-bold text-brand-dark mb-0">
                                        ✓ Authorized to perform end-to-end implementation
                                        of the ServiceNow AI Platform
                                    </p>
                                </div>

                                <ul className="list-unstyled d-flex flex-column gap-2 text-secondary mb-0">
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        ServiceNow strategy and consulting
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        Platform planning and architecture
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        ServiceNow implementation
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        Configuration and customization
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        Enterprise integrations
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        AI-powered ServiceNow solutions
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        Platform optimization and support
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Build Partner */}
                        <div className="col-md-6">
                            <div className="card h-100 p-4 p-md-5 border-0 shadow-sm rounded-4">

                                <div className="icon-box rounded-3 d-flex align-items-center justify-content-center mb-4 bg-brand-primary text-white">
                                    <span className="material-symbols-outlined fs-3">
                                        build
                                    </span>
                                </div>

                                <h3 className="h4 fw-bold mb-3 text-brand-dark">
                                    Build Partner
                                </h3>

                                <p className="text-secondary mb-5">
                                    Tiara Software provides ServiceNow Build Partner
                                    capabilities to develop custom ServiceNow Store
                                    applications that add platform value for ServiceNow
                                    customers.
                                </p>

                                <div className="mb-4 p-3 rounded-3 bg-light border">
                                    <p className="fw-bold text-brand-dark mb-0">
                                        ✓ Develop SN Store applications that add platform
                                        value for ServiceNow customers
                                    </p>
                                </div>

                                <ul className="list-unstyled d-flex flex-column gap-2 text-secondary mb-0">
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        Custom ServiceNow applications
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        ServiceNow Store applications
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        Platform extensions
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        Custom applications and user experiences
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        API integrations
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        Enterprise system integrations
                                    </li>
                                    <li>
                                        <span className="text-brand-primary me-2">✓</span>
                                        AI-powered applications
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="py-5 bg-white ServiceNow-DC-event">
                <div className="container py-5">

                    {/* Section Heading */}
                    <div className="text-center mb-5">
                        <span className="text-brand-primary fw-bold text-uppercase tracking-wide">
                            ServiceNow in Washington, DC
                        </span>

                        <h2 className="fw-bold text-brand-dark mt-2">
                            ServiceNow Summit Washington, DC
                        </h2>

                        <p
                            className="text-secondary mx-auto mb-0"
                            style={{ maxWidth: "800px" }}
                        >
                            Tiara Software's participation at ServiceNow Summit Washington, DC
                            reflects our involvement in the ServiceNow ecosystem and our
                            commitment to ServiceNow, AI-powered solutions and digital
                            transformation.
                        </p>
                    </div>


                    {/* Main Image + Event Content */}
                    {/* Main Event Section */}
                    <div className="row g-5 mb-5">

                        {/* LEFT COLUMN */}
                        <div className="col-lg-6">

                            {/* Main Image */}
                            <div className="rounded-4 overflow-hidden shadow-sm mb-4">
                                <img
                                    src={home}
                                    alt="Tiara Software team at ServiceNow Summit Washington DC"
                                    className="img-fluid w-100"
                                    loading="lazy"
                                    style={{
                                        objectFit: "contain",
                                        display: "block"
                                    }}
                                />
                            </div>

                            {/* Content Below Image */}
                            <div>
                                <h3 className="fw-bold text-brand-dark mb-3">
                                    ServiceNow Solutions and Digital Transformation
                                </h3>

                                <p className="text-secondary">
                                    Tiara Software's participation reflects our involvement
                                    in the <strong>ServiceNow ecosystem</strong> and our
                                    commitment to helping organizations explore modern
                                    ServiceNow capabilities, AI-powered solutions and
                                    digital transformation strategies.
                                </p>

                                <p className="text-secondary mb-0">
                                    Our expertise covers ServiceNow ITSM, CSM and HRSD,
                                    workflow automation and AI-powered service management
                                    solutions designed to help organizations improve
                                    operational efficiency and service delivery.
                                </p>
                            </div>

                        </div>


                        {/* RIGHT COLUMN */}
                        <div className="col-lg-6">

                            <span className="text-brand-primary fw-semibold text-uppercase">
                                ServiceNow Summit Washington, DC
                            </span>

                            <h3 className="fw-bold text-brand-dark mt-2 mb-3">
                                Tiara Consulting | Agentic AI Service Desk
                            </h3>

                            <p className="text-secondary">
                                Tiara Software participated in the{" "}
                                <strong>ServiceNow Summit Washington, DC</strong>,
                                showcasing our focus on ServiceNow solutions, Agentic AI,
                                workflow automation and digital transformation.
                            </p>

                            <p className="text-secondary">
                                The featured topic,{" "}
                                <strong>Agentic AI Service Desk</strong>, focuses on
                                <strong> live voice orchestration for ITSM, CSM and HRSD
                                    automation</strong>, including practical use cases such
                                as password reset automation.
                            </p>

                            <p className="text-secondary">
                                AI-powered service desk experiences can help organizations
                                streamline repetitive workflows, reduce manual service
                                desk tasks and improve how employees and customers interact
                                with enterprise services.
                            </p>


                            {/* Event Details */}
                            <div className="border rounded-4 p-4 bg-light mt-4">

                                <h4 className="fw-bold text-brand-dark mb-3">
                                    ServiceNow Summit Event Details
                                </h4>

                                <div className="d-flex align-items-start mb-3">
                                    <span className="material-symbols-outlined text-brand-primary me-3">
                                        calendar_month
                                    </span>

                                    <div>
                                        <strong className="text-brand-dark d-block">
                                            Date
                                        </strong>

                                        <span className="text-secondary">
                                            Tuesday, September 23, 2025
                                        </span>
                                    </div>
                                </div>


                                <div className="d-flex align-items-start mb-3">
                                    <span className="material-symbols-outlined text-brand-primary me-3">
                                        schedule
                                    </span>

                                    <div>
                                        <strong className="text-brand-dark d-block">
                                            Time
                                        </strong>

                                        <span className="text-secondary">
                                            12:45 AM – 1:15 PM EST
                                        </span>
                                    </div>
                                </div>


                                <div className="d-flex align-items-start">
                                    <span className="material-symbols-outlined text-brand-primary me-3">
                                        location_on
                                    </span>

                                    <div>
                                        <strong className="text-brand-dark d-block">
                                            Venue
                                        </strong>

                                        <span className="text-secondary">
                                            Marriott Marquis Washington D.C.
                                        </span>
                                    </div>
                                </div>

                            </div>


                            {/* PDF Button */}
                            {/* <a
                                href="/servicenow-summit-washington-dc"
                                className="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2 mt-4"
                            >
                                <span className="material-symbols-outlined">
                                    picture_as_pdf
                                </span>

                                Download Event PDF
                            </a> */}

                        </div>

                    </div>


                    {/* Image Gallery */}
                    <div className="mt-5">

                        <div className="text-center mb-4">
                            <h3 className="fw-bold text-brand-dark">
                                ServiceNow Summit Washington, DC Gallery
                            </h3>

                            <p className="text-secondary mb-0">
                                Highlights from Tiara Software's participation in the
                                ServiceNow Summit in Washington, DC.
                            </p>
                        </div>


                        <div className="row g-4">

                            {/* Image 2 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="overflow-hidden rounded-4 shadow-sm">
                                    <img
                                        src={img1}
                                        alt="Tiara Software at ServiceNow Summit Washington DC"
                                        className="img-fluid w-100"
                                        loading="lazy"
                                        style={{
                                            height: "240px",
                                            objectFit: "contain"
                                        }}
                                    />
                                </div>
                            </div>


                            {/* Image 3 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="overflow-hidden rounded-4 shadow-sm">
                                    <img
                                        src={img2}
                                        alt="ServiceNow Summit Washington DC event with Tiara Software"
                                        className="img-fluid w-100"
                                        loading="lazy"
                                        style={{
                                            height: "240px",
                                            objectFit: "contain"
                                        }}
                                    />
                                </div>
                            </div>


                            {/* Image 4 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="overflow-hidden rounded-4 shadow-sm">
                                    <img
                                        src={img3}
                                        alt="Tiara Software ServiceNow event participation in Washington DC"
                                        className="img-fluid w-100"
                                        loading="lazy"
                                        style={{
                                            height: "240px",
                                            objectFit: "contain"
                                        }}
                                    />
                                </div>
                            </div>


                            {/* Image 5 */}
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="overflow-hidden rounded-4 shadow-sm">
                                    <img
                                        src={img4}
                                        alt="Tiara Software team at ServiceNow event in Washington DC"
                                        className="img-fluid w-100"
                                        loading="lazy"
                                        style={{
                                            height: "240px",
                                            objectFit: "contain"
                                        }}
                                    />
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </section>

            {/* 4. DC Focus & Service Breakdowns */}
            <section className="py-5 bg-white ServiceNow-DC-focus">
                <div className="container py-5">

                    <div className="row gy-5">

                        {/* Introduction */}
                        <div className="col-lg-5">

                            {/* ServiceNow Partner Logo */}
                            <div className="mb-4">
                                <img
                                    src={servicenowpartner}
                                    alt="ServiceNow Partner"
                                    className="img-fluid"
                                    width="180"
                                    loading="lazy"
                                />
                            </div>

                            <h2 className="fw-bold mb-4 text-brand-dark">
                                ServiceNow Consulting &amp; Implementation in Washington, DC
                            </h2>

                            <p className="text-secondary mb-4">
                                Our <strong>ServiceNow consulting and implementation
                                    services</strong> help organizations plan, configure and
                                optimize ServiceNow solutions around their business
                                requirements. From initial requirements and solution
                                planning to implementation, integration and ongoing
                                platform improvement, Tiara Software supports organizations
                                throughout their ServiceNow journey.
                            </p>

                        </div>


                        {/* ServiceNow Capabilities */}
                        <div className="col-lg-7">

                            <div className="row gy-4">

                                {[
                                    {
                                        title: "ServiceNow Consulting",
                                        desc: "Get strategic guidance for your ServiceNow roadmap, platform architecture, configuration and platform optimization."
                                    },
                                    {
                                        title: "ServiceNow Implementation",
                                        desc: "Plan and implement ServiceNow solutions based on your organization's processes, users, applications and business requirements."
                                    },
                                    {
                                        title: "ServiceNow Integration",
                                        desc: "Connect ServiceNow with enterprise applications, APIs and existing technology systems to improve data exchange and connected business processes."
                                    },
                                    {
                                        title: "ServiceNow Development & Customization",
                                        desc: "Develop and customize ServiceNow applications, scripts and platform functionality to address specific business requirements."
                                    },
                                    {
                                        title: "ServiceNow Support & Optimization",
                                        desc: "Maintain and improve your ServiceNow environment through ongoing support, enhancements, troubleshooting and platform optimization."
                                    },
                                    {
                                        title: "ServiceNow AI & Agentic AI",
                                        desc: "Explore AI-powered ServiceNow solutions, intelligent automation and agentic AI capabilities designed to improve service experiences and automate business workflows."
                                    }
                                ].map((item, index) => (
                                    <div className="col-md-6" key={index}>
                                        <div className="p-4 border rounded-3 h-100 shadow-sm bg-light">

                                            <h3 className="h6 fw-bold text-brand-dark">
                                                {item.title}
                                            </h3>

                                            <p className="small text-secondary mb-0">
                                                {item.desc}
                                            </p>

                                        </div>
                                    </div>
                                ))}

                            </div>

                        </div>

                    </div>

                </div>
            </section>

            {/* 5. Implementation Approach (Timeline) */}
            <section className="bg-brand-inverse text-white py-5 ServiceNow-DC-approach">
                <div className="container py-5">

                    <div className="text-center mb-5">

                        <span className="step-badge fw-bold text-uppercase">
                            ServiceNow Implementation
                        </span>

                        <h2 className="fw-bold mb-3 mt-2">
                            Our ServiceNow Implementation Approach
                        </h2>

                        <p
                            className="mb-0"
                            style={{ color: "#c4d2ff" }}
                        >
                            Requirement Analysis → Design → Configure → Develop →
                            Integrate → Test → UAT → Deploy → Validate → Support
                        </p>

                    </div>

                    <div className="mx-auto" style={{ maxWidth: "800px" }}>

                        {[
                            {
                                step: "01",
                                title: "Requirement Analysis",
                                desc: "Understand business processes, identify workflows, define roles and document gaps between current systems and the desired ServiceNow solution."
                            },
                            {
                                step: "02",
                                title: "Solution & Architecture Design",
                                desc: "Design the solution architecture, user experiences and integration approach while determining where standard ServiceNow configuration is appropriate and where customization may be required."
                            },
                            {
                                step: "03",
                                title: "ServiceNow Configuration",
                                desc: "Configure applications, forms, workflows, assignment rules, client scripts, UI policies, access controls and other ServiceNow platform capabilities based on business requirements."
                            },
                            {
                                step: "04",
                                title: "Custom Development",
                                desc: "Develop custom applications, scripts and workflows where required while minimizing unnecessary platform customization and maintaining long-term maintainability."
                            },
                            {
                                step: "05",
                                title: "ServiceNow Integration",
                                desc: "Connect ServiceNow with external applications and enterprise systems using appropriate integration technologies such as REST APIs, Integration Hub and MID Server."
                            },
                            {
                                step: "06",
                                title: "Testing & User Acceptance",
                                desc: "Perform functional, integration and end-to-end testing, validate roles and access, and work with business users during User Acceptance Testing (UAT)."
                            },
                            {
                                step: "07",
                                title: "Deployment",
                                desc: "Move approved changes through development, testing and production environments while validating dependencies, configurations and deployment readiness."
                            },
                            {
                                step: "08",
                                title: "Production Validation & Support",
                                desc: "Perform post-deployment validation, verify integrations and workflows, monitor the environment and provide knowledge transfer and ongoing support."
                            }
                        ].map((item, index) => (
                            <div
                                className="d-flex align-items-start gap-4 mb-3"
                                key={index}
                            >

                                <div className="d-flex flex-column align-items-center">

                                    <div className="step-circle rounded-circle d-flex align-items-center justify-content-center fw-bold z-1 text-white">
                                        {item.step}
                                    </div>

                                    {index !== 7 && (
                                        <div className="step-line my-2"></div>
                                    )}

                                </div>

                                <div
                                    className="flex-grow-1 p-4 rounded-3 border border-secondary"
                                    style={{
                                        backgroundColor: "rgba(255,255,255,0.05)"
                                    }}
                                >
                                    <h3 className="h5 fw-bold mb-2">
                                        {item.title}
                                    </h3>

                                    <p
                                        className="mb-0 small"
                                        style={{ color: "#c4d2ff" }}
                                    >
                                        {item.desc}
                                    </p>
                                </div>

                            </div>
                        ))}

                    </div>

                </div>
            </section>

            {/* 6. Platform Capabilities (Detailed Grid) */}
            <section className="py-5 bg-white ServiceNow-DC-capabilities">
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold text-brand-dark">ServiceNow Platform Capabilities</h2>
                        <p className="text-secondary max-w-2xl mx-auto">Tiara Software can help organizations explore and implement ServiceNow capabilities across multiple areas of the platform.</p>
                    </div>

                    <div className="row gy-4">
                        {[
                            { icon: 'support_agent', title: 'IT Service Management (ITSM)', desc: 'Improve incident, problem, change, request and service management processes through structured ServiceNow solutions.' },
                            { icon: 'manage_accounts', title: 'Customer Service Management (CSM)', desc: 'Connect customer service processes, teams and service experiences to deliver more consistent customer experiences.' },
                            { icon: 'badge', title: 'HR Service Delivery (HRSD)', desc: 'Modernize employee service delivery and improve HR-related requests and processes.' },
                            { icon: 'dns', title: 'IT Operations Management (ITOM)', desc: 'Improve visibility and management of IT operations, infrastructure and services.' },
                            { icon: 'inventory_2', title: 'IT Asset Management (ITAM)', desc: 'Manage technology assets, lifecycle processes and asset-related information across the organization.' },
                            { icon: 'account_tree', title: 'Configuration Management Database (CMDB)', desc: 'Create better visibility into configuration items, relationships and the technology environment supporting business services.' },
                            { icon: 'security', title: 'Security Operations (SecOps)', desc: 'Support security operations processes and connect security workflows with broader enterprise service management.' },
                            { icon: 'monitoring', title: 'Strategic Portfolio Management (SPM)', desc: 'Connect strategic planning, portfolios, projects and business priorities through ServiceNow.' },
                            { icon: 'shopping_cart', title: 'Procurement', desc: 'Improve procurement-related processes and visibility across purchasing activities.' },
                            { icon: 'public', title: 'Public Sector Digital Services (PSDS)', desc: 'Support digital service delivery and platform modernization for public-sector environments where applicable.' },
                            {
                                icon: 'smart_toy',
                                title: 'AI Experiences (Now Assist)',
                                desc: 'Empower users and agents with generative AI capabilities, contextual search, and conversational self-service embedded natively across your workflows.'
                            },
                            {
                                icon: 'hub',
                                title: 'ITOM AIOps',
                                desc: 'Leverage machine learning to correlate events, detect anomalies early, and automate incident remediation across enterprise infrastructure and services.'
                            }
                        ].map((skill, idx) => (
                            <div className="col-md-6 col-lg-4" key={idx}>
                                <div className="p-4 border rounded-3 h-100 shadow-sm d-flex gap-3 hover-border-primary transition">
                                    <span className="material-symbols-outlined text-brand-primary fs-2 flex-shrink-0">{skill.icon}</span>
                                    <div>
                                        <h4 className="h6 fw-bold text-brand-dark mb-2">{skill.title}</h4>
                                        <p className="small text-secondary mb-0">{skill.desc}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 7. AI & Intelligent Automation */}
            <section
                className="py-5 ServiceNow-DC-ai"
                style={{ backgroundColor: '#e8edff' }}
            >
                <div className="container py-5">
                    <div className="row align-items-center gy-4">

                        {/* AI Content */}
                        <div className="col-lg-6">


                            <h2 className="fw-bold text-brand-dark mb-3">
                                ServiceNow AI &amp; Intelligent Automation
                            </h2>

                            <h3 className="h5 text-brand-primary mb-4">
                                Put ServiceNow AI to Work
                            </h3>

                            <p className="text-secondary mb-4">
                                Organizations are increasingly looking to combine ServiceNow
                                with AI and intelligent automation to improve employee
                                experiences, automate processes and help teams work more
                                efficiently.
                            </p>

                            <p className="text-secondary mb-0">
                                Our approach focuses on applying AI to practical business
                                requirements and ServiceNow use cases rather than adding
                                technology without a clear business purpose.
                            </p>
                        </div>

                        {/* AI Capabilities */}
                        <div className="col-lg-6">
                            <div className="glass-card p-4 p-md-5 rounded-4 shadow-sm border-0">

                                <h4 className="h6 fw-bold mb-4 text-brand-dark">
                                    Tiara Software provides solutions around:
                                </h4>

                                <div className="row g-3">
                                    {[

                                        'Now Assist',
                                        'AI Agents',
                                        'Agentic AI',
                                        'Intelligent automation',
                                        'Enterprise integrations',
                                        'Automated service processes',
                                        'AI-powered ServiceNow experiences',
                                    ].map((item, i) => (
                                        <div className="col-sm-6" key={i}>
                                            <div className="d-flex align-items-center gap-2">
                                                <span className="material-symbols-outlined text-brand-primary fs-5">
                                                    check_circle
                                                </span>

                                                <span className="small text-secondary fw-semibold">
                                                    {item}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* 8. ServiceNow Training */}
            <section className="py-5 bg-white ServiceNow-DC-training">
                <div className="container py-5">


                    {/* Training Introduction */}
                    <div className="row align-items-center gy-4 mb-5">

                        {/* Logo + Training Content */}
                        <div className="col-lg-8">

                            {/* ServiceNow Logo */}
                            <div className="mb-4">
                                <img
                                    src={servicenowpartner}
                                    alt="ServiceNow logo"
                                    className="img-fluid"
                                    width="180"
                                    loading="lazy"
                                />
                            </div>

                            {/* Training Content */}
                            <h2 className="fw-bold text-brand-dark mb-2">
                                ServiceNow Training
                            </h2>

                            <h3 className="h5 text-brand-primary mb-3">
                                Get Trained. Get Certified. Build Practical Skills.
                            </h3>

                            <p className="text-secondary mb-0">
                                ServiceNow is used across a wide range of enterprise service
                                management and digital service environments. Tiara Software
                                provides ServiceNow training for professionals who want to
                                develop practical skills across administration, development,
                                business analysis and AI.
                            </p>

                        </div>


                        {/* Training Image */}
                        <div className="col-lg-4">

                            <img
                                src={eventimg2}
                                alt="ServiceNow training for administrators, developers, business analysts and AI specialists"
                                className="img-fluid rounded-4 shadow-sm"
                                width="600"
                                height="400"
                                loading="lazy"
                            />

                        </div>

                    </div>

                    {/* Training Features & Learning Paths */}
                    <div className="row gy-5 mb-5">

                        {/* Training Features */}
                        <div className="col-lg-4">
                            <div className="bg-brand-primary text-white p-4 rounded-4 shadow h-100">

                                <h4 className="h5 fw-bold mb-4 border-bottom border-light pb-3">
                                    ServiceNow Training
                                </h4>

                                <ul className="list-unstyled d-flex flex-column gap-3 mb-4">
                                    <li>
                                        ✓ Get Trained in ServiceNow
                                    </li>
                                    <li>
                                        ✓ Get Certified by ServiceNow
                                    </li>
                                    <li>
                                        ✓ Online or Classroom Training
                                    </li>
                                    <li>
                                        ✓ Fees ($$) and Terms Apply
                                    </li>
                                    <li>
                                        ✓ Gain Practical Experience
                                    </li>
                                    <li>
                                        ✓ ServiceNow Admin | Developer | BA | AI Specialist
                                    </li>
                                    <li>
                                        ✓ Win Full-Time or Contract Job Opportunities
                                    </li>
                                </ul>

                                <a
                                    href="/snconfirmation"
                                    className="btn btn-light  w-100 fw-bold"
                                >
                                    Register for ServiceNow Training
                                </a>

                            </div>
                        </div>

                        {/* Training Tracks */}
                        {/* <div className="col-lg-8">
                            <div className="row g-4 h-100">

                                {[
                                    {
                                        title: "ServiceNow Administrator Training",
                                        icon: "admin_panel_settings",
                                        desc: "Build practical knowledge of ServiceNow administration, configuration, platform functionality and day-to-day platform management."
                                    },
                                    {
                                        title: "ServiceNow Developer Training",
                                        icon: "code",
                                        desc: "Develop technical skills in ServiceNow development, scripting, integrations, applications and platform customization."
                                    },
                                    {
                                        title: "ServiceNow Business Analyst Training",
                                        icon: "analytics",
                                        desc: "Learn how to understand business requirements, analyze processes and translate organizational needs into ServiceNow solutions."
                                    },
                                    {
                                        title: "ServiceNow AI Specialist Training",
                                        icon: "psychology",
                                        desc: "Develop knowledge around AI-powered ServiceNow capabilities, AI experiences, automation and emerging AI technologies."
                                    }
                                ].map((track, i) => (
                                    <div className="col-md-6" key={i}>
                                        <div className="p-4 border rounded-3 bg-light h-100">

                                            <div className="d-flex align-items-center gap-3 mb-3">
                                                <span className="material-symbols-outlined text-brand-primary fs-3">
                                                    {track.icon}
                                                </span>

                                                <h4 className="h6 fw-bold text-brand-dark mb-0">
                                                    {track.title}
                                                </h4>
                                            </div>

                                            <p className="small text-secondary mb-0">
                                                {track.desc}
                                            </p>

                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div> */}
                        <div className="col-lg-8">
                            <div className="row g-4 h-100">

                                {/* Certification Type */}
                                <div className="col-md-6">
                                    <div className="p-4 border rounded-3 bg-light h-100">

                                        <div className="d-flex align-items-center gap-3 mb-4">
                                            <span className="material-symbols-outlined text-brand-primary fs-3">
                                                verified
                                            </span>

                                            <h4 className="h5 fw-bold text-brand-dark mb-0">
                                                Certification Type
                                            </h4>
                                        </div>

                                        <div className="d-flex flex-column gap-3">

                                            <div>
                                                <h5 className="h6 fw-bold text-brand-dark mb-1">
                                                    Cert. System Admin (CSA)
                                                </h5>
                                                <p className="small text-secondary mb-0">
                                                    For Functional / BA / QA Tester roles
                                                </p>
                                            </div>

                                            <div>
                                                <h5 className="h6 fw-bold text-brand-dark mb-1">
                                                    Cert. App Developer (CAD)
                                                </h5>
                                                <p className="small text-secondary mb-0">
                                                    Pure Technical Role
                                                </p>
                                            </div>

                                            <div>
                                                <h5 className="h6 fw-bold text-brand-dark mb-1">
                                                    Training Only
                                                </h5>
                                                <p className="small text-secondary mb-0">
                                                    No Certification
                                                </p>
                                            </div>

                                            <div>
                                                <h5 className="h6 fw-bold text-brand-dark mb-0">
                                                    Others
                                                </h5>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* Training Mode */}
                                <div className="col-md-6">
                                    <div className="p-4 border rounded-3 bg-light h-100">

                                        <div className="d-flex align-items-center gap-3 mb-4">
                                            <span className="material-symbols-outlined text-brand-primary fs-3">
                                                school
                                            </span>

                                            <h4 className="h5 fw-bold text-brand-dark mb-0">
                                                Training Mode
                                            </h4>
                                        </div>

                                        <div className="d-flex flex-column gap-4">

                                            <div className="d-flex align-items-start gap-3">
                                                <span className="material-symbols-outlined text-brand-primary">
                                                    laptop_mac
                                                </span>

                                                <div>
                                                    <h5 className="h6 fw-bold text-brand-dark mb-1">
                                                        Online
                                                    </h5>
                                                    <p className="small text-secondary mb-0">
                                                        Learn ServiceNow from with online training.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-start gap-3">
                                                <span className="material-symbols-outlined text-brand-primary">
                                                    groups
                                                </span>

                                                <div>
                                                    <h5 className="h6 fw-bold text-brand-dark mb-1">
                                                        Classroom
                                                    </h5>
                                                    <p className="small text-secondary mb-0">
                                                        Classroom training available on request.
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* Training Areas */}
                                <div className="col-12">
                                    <div className="p-4 border rounded-3 bg-light">

                                        <div className="d-flex align-items-center gap-3 mb-3">
                                            <span className="material-symbols-outlined text-brand-primary fs-3">
                                                model_training
                                            </span>

                                            <h4 className="h5 fw-bold text-brand-dark mb-0">
                                                ServiceNow Training Areas
                                            </h4>
                                        </div>

                                        <div className="row g-3">
                                            <div className="col-sm-6 col-lg-3">
                                                <div className="small fw-semibold text-brand-dark">
                                                    ✓ ServiceNow Administrator
                                                </div>
                                            </div>

                                            <div className="col-sm-6 col-lg-3">
                                                <div className="small fw-semibold text-brand-dark">
                                                    ✓ ServiceNow Developer
                                                </div>
                                            </div>

                                            <div className="col-sm-6 col-lg-3">
                                                <div className="small fw-semibold text-brand-dark">
                                                    ✓ ServiceNow Business Analyst
                                                </div>
                                            </div>

                                            <div className="col-sm-6 col-lg-3">
                                                <div className="small fw-semibold text-brand-dark">
                                                    ✓ ServiceNow AI Specialist
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    {/* Training Disclaimer */}
                    {/* <div className="bg-light p-4 rounded-3 border text-center">
                        <p className="small text-secondary mb-0">
                            <strong>Note:</strong> Training fees and terms apply.
                            Certification outcomes depend on the applicable ServiceNow
                            certification requirements and examination process. Training
                            can help learners prepare for full-time and contract
                            ServiceNow opportunities, but employment is not guaranteed.
                        </p>
                    </div> */}

                </div>
            </section>

            {/* 9. Why Choose Tiara Software */}
            <section className="py-5 bg-light ServiceNow-DC-why">
                <div className="container py-5">

                    <div className="text-center mb-5">
                        <span className="text-brand-primary fw-bold text-uppercase tracking-wide">
                            Why Tiara Software
                        </span>

                        <h2 className="fw-bold text-brand-dark mt-2">
                            Why Choose Tiara Software for ServiceNow?
                        </h2>

                        <p className="text-secondary mx-auto mb-0" style={{ maxWidth: "800px" }}>
                            Tiara Software combines ServiceNow consulting, implementation,
                            development, AI, training and ongoing support to help
                            organizations build solutions around their business needs.
                        </p>
                    </div>

                    <div className="row gy-4">

                        {[
                            {
                                title: "End-to-End Capabilities",
                                desc: "Support across ServiceNow consulting, implementation, integration, development, AI solutions, training and ongoing optimization."
                            },
                            {
                                title: "ServiceNow Partner",
                                desc: "ServiceNow implementation capabilities designed around your organization's processes, technology environment and business requirements."
                            },
                            {
                                title: "Build Partner Expertise",
                                desc: "Custom ServiceNow application development that extends platform capabilities and addresses specific business requirements."
                            },
                            {
                                title: "Business-Focused Approach",
                                desc: "We begin with your business processes and requirements before designing and implementing ServiceNow solutions."
                            },
                            {
                                title: "Custom Development",
                                desc: "Extend ServiceNow through custom applications, integrations, scripts and platform functionality."
                            },
                            {
                                title: "AI & Intelligent Automation",
                                desc: "Explore ServiceNow AI, AI agents, intelligent automation and emerging agentic AI capabilities where they fit your business needs."
                            },
                            {
                                title: "Professional Training",
                                desc: "Build practical ServiceNow skills across administration, development, business analysis and AI through professional training programs."
                            },
                            {
                                title: "Long-Term Platform Growth",
                                desc: "Continue improving your ServiceNow environment as your business processes, technology needs and digital transformation goals evolve."
                            }
                        ].map((reason, idx) => (
                            <div className="col-md-6 col-lg-3" key={idx}>
                                <div className="bg-white p-4 rounded-3 shadow-sm border h-100 text-center">

                                    <h3 className="h6 fw-bold text-brand-primary mb-3">
                                        {reason.title}
                                    </h3>

                                    <p className="small text-secondary mb-0">
                                        {reason.desc}
                                    </p>

                                </div>
                            </div>
                        ))}

                    </div>

                </div>
            </section>

            {/* 10. Washington DC Focus Block & Industries */}
            <section className="py-5 bg-white ServiceNow-DC-local-industries">
                <div className="container py-5">

                    <div className="row gy-5">

                        {/* Washington, DC Focus */}
                        <div className="col-lg-6">

                            <span className="text-brand-primary fw-bold text-uppercase tracking-wide">
                                ServiceNow in Washington, DC
                            </span>

                            <h2 className="fw-bold mb-4 mt-2 text-brand-dark">
                                ServiceNow Consulting &amp; Solutions for Washington, DC Organizations
                            </h2>

                            <div className="bg-light p-4 rounded-4 border-start border-4 border-primary">

                                <p className="text-secondary mb-3">
                                    Organizations in Washington, DC and surrounding business
                                    markets can use ServiceNow to modernize service management,
                                    automate workflows, connect enterprise systems and improve
                                    digital experiences.
                                </p>

                                <p className="text-secondary mb-3">
                                    Tiara Software helps organizations evaluate, implement and
                                    improve ServiceNow solutions based on their business
                                    processes, technology environment and digital transformation
                                    goals.
                                </p>

                                <p className="text-secondary mb-3">
                                    Whether you are planning a new ServiceNow implementation,
                                    improving an existing instance, developing a custom
                                    application or exploring ServiceNow AI and workflow
                                    automation, our team can help you determine an appropriate
                                    approach.
                                </p>

                                <p className="text-secondary mb-0">
                                    We also provide ServiceNow training for professionals who
                                    want to develop practical skills in administration,
                                    development, business analysis and AI.
                                </p>

                            </div>

                        </div>


                        {/* Industries */}
                        <div className="col-lg-6">

                            <span className="text-brand-primary fw-bold text-uppercase tracking-wide">
                                Industry Experience
                            </span>

                            <h2 className="fw-bold mb-4 mt-2 text-brand-dark">
                                ServiceNow Solutions Across Industries
                            </h2>

                            <div className="row g-3">

                                {[
                                    {
                                        title: "Healthcare",
                                        desc: "Service management, workflow automation and connected enterprise services.",
                                        icon: "local_hospital"
                                    },
                                    {
                                        title: "Financial Services",
                                        desc: "Structured service processes, operations and enterprise workflow automation.",
                                        icon: "account_balance"
                                    },
                                    {
                                        title: "Manufacturing",
                                        desc: "IT operations, asset management, service processes and operational visibility.",
                                        icon: "factory"
                                    },
                                    {
                                        title: "Technology",
                                        desc: "ITSM, ITOM, integrations, automation and custom ServiceNow applications.",
                                        icon: "devices"
                                    },
                                    {
                                        title: "Professional Services",
                                        desc: "Service delivery, employee services and enterprise process management.",
                                        icon: "work"
                                    },
                                    {
                                        title: "Public Sector",
                                        desc: "Digital service processes, IT service management and platform modernization.",
                                        icon: "account_balance"
                                    }
                                ].map((industry, i) => (
                                    <div className="col-sm-6" key={i}>

                                        <div className="p-3 border rounded-3 h-100 d-flex flex-column gap-2 hover-border-primary">

                                            <span className="material-symbols-outlined text-brand-primary">
                                                {industry.icon}
                                            </span>

                                            <h3 className="h6 fw-bold mb-0 text-brand-dark">
                                                {industry.title}
                                            </h3>

                                            <p className="small text-secondary mb-0">
                                                {industry.desc}
                                            </p>

                                        </div>

                                    </div>
                                ))}

                            </div>

                        </div>

                    </div>

                </div>
            </section>
            {/* 11. FAQ Section */}
            <section className="py-5 bg-light ServiceNow-DC-faq">
                <div className="container py-5" style={{ maxWidth: "900px" }}>

                    <div className="text-center mb-5">
                        <h2 className="fw-bold text-brand-dark">
                            Frequently Asked Questions
                        </h2>
                    </div>

                    <div className="d-flex flex-column gap-3">
                        {[
                            {
                                q: "What does a ServiceNow partner do?",
                                a: "A ServiceNow partner helps organizations plan, implement, configure, customize, integrate and optimize ServiceNow solutions based on their business requirements. A partner can also provide consulting, development, support, training and AI-powered ServiceNow solutions."
                            },
                            {
                                q: "What ServiceNow implementation services does Tiara Software provide?",
                                a: "Tiara Software provides ServiceNow implementation services covering platform planning, configuration, customization, integrations, deployment and optimization. Our services can support organizations implementing ServiceNow to improve IT service management, customer service, HR workflows and digital transformation."
                            },
                            {
                                q: "Does Tiara Software provide ServiceNow application development?",
                                a: "Yes. Tiara Software provides ServiceNow application development and customization capabilities, including custom applications designed to extend the ServiceNow platform and address specific business requirements."
                            },
                            {
                                q: "Does Tiara Software provide ServiceNow training?",
                                a: "Yes. Tiara Software provides ServiceNow training programs covering areas such as ServiceNow Administration, ServiceNow Development, ServiceNow Business Analysis and ServiceNow AI. Training may be available through online and classroom formats depending on the applicable course schedule."
                            },
                            {
                                q: "Does Tiara Software serve organizations outside Washington, DC?",
                                a: "Yes. While Tiara Software supports organizations with ServiceNow requirements in Washington, DC, our ServiceNow consulting, implementation, integration, application development, AI solutions, support and training services can also support organizations in other locations."
                            }
                        ].map((faq, idx) => (
                            <details
                                className="bg-white border rounded-3 p-3 shadow-sm"
                                key={idx}
                                style={{ cursor: "pointer" }}
                            >
                                <summary
                                    className="fw-bold text-brand-dark"
                                    style={{
                                        listStyle: "none",
                                        position: "relative"
                                    }}
                                >
                                    <span className="d-flex justify-content-between align-items-center">
                                        {faq.q}

                                        <span className="material-symbols-outlined text-brand-primary">
                                            expand_more
                                        </span>
                                    </span>
                                </summary>

                                <div className="mt-3 pt-3 border-top text-secondary small">
                                    {faq.a}
                                </div>
                            </details>
                        ))}
                    </div>

                </div>
            </section>

            {/* 12. Final CTA */}
            <section className="bg-brand-primary text-white py-5 text-center ServiceNow-DC-cta">
                <div className="container py-5">

                    <div className="mx-auto" style={{ maxWidth: "800px" }}>

                        <span className="text-uppercase fw-semibold small">
                            Get Started with ServiceNow
                        </span>

                        <h2 className="display-6 fw-bold mt-2 mb-4">
                            Ready to Get More From ServiceNow?
                        </h2>

                        <p
                            className="lead mb-5"
                            style={{ color: "#b2c5ff" }}
                        >
                            Whether you need ServiceNow consulting, implementation,
                            custom application development, AI-powered solutions or
                            professional ServiceNow training, Tiara Software can help
                            you take the next step.
                        </p>

                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">

                            {/* Contact Us */}
                            <a
                                href="/contact"
                                className="btn btn-light fw-bold px-4 py-3 shadow-sm"
                                style={{ borderRadius: "0.5rem" }}
                            >
                                Contact our ServiceNow Experts
                            </a>

                            {/* ServiceNow Training */}
                            <a
                                href="/snconfirmation"
                                className="btn-brand-secondary-light px-4 py-3 text-decoration-none shadow-sm"
                                style={{ borderRadius: "0.5rem" }}
                            >
                                Register for ServiceNow Training
                            </a>

                        </div>

                    </div>

                </div>
            </section>
        </div>
    );
};


export default ServiceNowWashingtonDC;